'use strict'
module.exports = require('./component/NowtifyBox');



/** WEBPACK FOOTER **
 ** ./src/entry.js
 **/